import React from 'react';

const LoadingSpinner = ({ size = 12, className = '' }) => (
  <div className="flex items-center justify-center">
    <span className="inline-block w-12 h-12 border-4 border-t-transparent border-b-transparent border-l-primary border-r-accent rounded-full animate-spin bg-gradient-to-r from-primary to-accent"></span>
  </div>
);

export default LoadingSpinner; 